<template>
	<div class="card">
		<div class="card-body">
			<div class="card-title flex items-center gap-2 text-xl">
				<StatusLight type="module" :_id="baseStore.getActiveIds.moduleId||''" />
				<span>{{ _tr('modules.title') }}</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import StatusLight from '@/components/StatusLight.vue'
	import { useBaseStore } from '@/stores/base.store'
	import { useI18n } from 'vue-i18n'
	import { _translations } from './_translations'

	const { t: _tr } = useI18n(_translations)
	const baseStore = useBaseStore()
</script>
